import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import createTypeService from '../services/createTypeService';
import TypeForm from './TypeForm';
import { mapFormToIdentificationCodeType } from '../helpers/mapFormToIdentificationCodeType';

const EMPTY_ORG_ROLE = {};

const NewType = ({
  open,
  dispatchCreateIdentificationCodeTypePost,
  createIdentificationCodeTypeFetch,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    body =>
      dispatchCreateIdentificationCodeTypePost(
        mapFormToIdentificationCodeType(body),
        () => navigate(`/identificationcodetypes`),
        t
      ),
    [dispatchCreateIdentificationCodeTypePost, t, navigate]
  );

  if (!open) return null;

  return (
    <TypeForm
      header={t('newIdentificationCodeType')}
      onSubmit={handleSubmit}
      submitProcessing={createIdentificationCodeTypeFetch.pending}
      returnRoute="/identificationcodetypes"
      cancelRoute="/identificationcodetypes"
      data={EMPTY_ORG_ROLE}
    />
  );
};

NewType.propTypes = {
  dispatchCreateIdentificationCodeTypePost: PropTypes.func.isRequired,
  createIdentificationCodeTypeFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

NewType.defaultProps = { open: false };

export default createTypeService(NewType);
